import { createSelector } from 'reselect'

import { selectPlanningWizardState } from './selectPlanningWizardState'

export const selectWizardError = createSelector(
  [selectPlanningWizardState],
  (planningWizard) => planningWizard.error
)
